import { updateCompleteWorkOrderPageOrigination } from "actions/updateCompleteWorkOrderPageOrigination";
import { updateRaiseWorkOrderDetails } from "actions/updateRaiseWorkOrderDetails";
import { updateViewWorkOrderPageOrigination } from "actions/updateViewWorkOrderPageOrigination";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IContainerStatusViewModel from "interfaces/IContainerStatusViewModel";
import IRaiseWorkOrderDetails from "interfaces/IRaiseWorkOrderDetails";
import { useStateMachine } from "little-state-machine";
import { IsNonSiteUser } from "modules/CheckPermissions";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const WorkOrderTemplate = (props: IContainerStatusViewModel): any => {
  const container = { props };
  const navigate = useNavigate();
  const { state } = useStateMachine();

  const { actions } = useStateMachine({
    updateRaiseWorkOrderDetails,
    updateViewWorkOrderPageOrigination,
    updateCompleteWorkOrderPageOrigination
  });

  const navigateToRaiseWorkOrder = () => {
    const raiseWorkOrderDetails : IRaiseWorkOrderDetails = {
      containerId: container.props.id,
      containerType: `${container.props.wasteType} - ${container.props.size}`,
      hwrcSiteName: container.props.hwrcSite,
      regionId: container.props.regionId,
      regionName: container.props.region,
      pageOrigination: RoutePathsEnum.Containers
    };

    actions.updateRaiseWorkOrderDetails(raiseWorkOrderDetails);
    navigate(RoutePathsEnum.WorkOrderRaise);
  };

  const navigateToViewWorkOrder = () => {
    actions.updateViewWorkOrderPageOrigination(RoutePathsEnum.Containers);
    actions.updateCompleteWorkOrderPageOrigination(RoutePathsEnum.WorkOrderView);
    navigate(`${RoutePathsEnum.WorkOrderView}/${container.props.workOrderReferenceNumber}`);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      {container.props.workOrderReferenceNumber
      && (
        <span>
          <Button
            onClick={navigateToViewWorkOrder}
            className="btn-link"
          >
            {container.props.workOrderReferenceNumber}

          </Button>
        </span>
      ) }

      {container.props.aboveThreshold && !container.props.workOrderReferenceNumber && IsNonSiteUser(state.userRole!)
      && (
        <Button
          variant="primary"
          className="px-4"
          onClick={navigateToRaiseWorkOrder}
          data-testid={`btn-new-work-order-${container.props.id}`}
          aria-label={`Add new work order for container ${container.props.name}`}
        >
          Add New
        </Button>
      )}
    </div>
  );
};
export default WorkOrderTemplate;
